var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.doc)?_c('div',{staticClass:"wl-results"},[_c('results-summary',{attrs:{"id":_vm.doc.id}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }